

export default function (props) {
    let sizeClass;
    switch (props.size) {
        case 'xs':
            sizeClass="w-4 h-4 border-2 " 
            break;
        case 'sm':
            sizeClass="w-8 h-8 border-3 "
            break;
        case 'md':
            sizeClass="w-12 h-12 border-3 "
            break; 
        case 'lg':
            sizeClass="w-16 h-16 border-4 "
            break;
        default:
            break;
    }

    if (props.withBackground) {
        return (
            <div className="grid justify-items-center bg-white py-4">
                 <div 
                    style={{borderTopColor:'white'}}
                    className={`${sizeClass} border-t-white border-black border-solid rounded-full animate-spin`}
                />
            </div> 
        )
    };

    return (
        <div 
            style={{borderTopColor:'white'}}
            className={`${sizeClass} ${props.className} border-t-white border-black border-solid rounded-full animate-spin`}
        />
    )
}